// extracted by mini-css-extract-plugin
module.exports = {"order-search":"FbackSearch_style_order-search__5Ca1v"};